import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { EditableGridService, SystemApiService } from '@cv-invision/core';
import { DefaultSettingsModel } from '../model/nexsys-default-setting.model';

@Injectable({
	providedIn: 'root'
})
export class NexsysDefaultSettingService extends EditableGridService {
	private readonly BASE_URL = `${this.systemApiService.api.orders}/utils/nexsys/default-settings`;

	constructor(private httpClient: HttpClient, private systemApiService: SystemApiService) {
		super();
	}

	/**
	 * PUT - Save the configuration.
	 */
	saveNexsysDefaultSettings(config: DefaultSettingsModel): Observable<any> {
		return this.httpClient.put(this.BASE_URL, config);
	}

	/**
	 * GET - Return the list of the  Default Settings configuration mappings.
	 */
	getNexsysDefaultSettings(): Observable<any> {
		return this.httpClient.get(this.BASE_URL);
	}
}
